
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/variants/renters/a-sticky-header-check-our-prices",
      function () {
        return require("private-next-pages/variants/renters/a-sticky-header-check-our-prices.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/variants/renters/a-sticky-header-check-our-prices"])
      });
    }
  